import React, { useState } from "react";
import styled from "styled-components";
import { clearCache } from "../../utils/pwaManager";

/**
 * Clear Cache Button
 * Fixed position button on top-left corner with warning color
 * Sends clear cache command to PWA service worker
 */

var ButtonWrapper = styled.div`
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 99999;
`;

var CacheButton = styled.button`
  display: inline-block;
  padding: 10px 18px;
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.9) 0%, rgba(245, 124, 0, 0.95) 100%);
  border: 2px solid rgba(255, 193, 7, 0.4);
  border-radius: 12px;
  color: #fff;
  font-family: "AnjomanMax", sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
  white-space: nowrap;

  &:hover {
    background: linear-gradient(135deg, rgba(255, 167, 38, 0.95) 0%, rgba(255, 143, 0, 1) 100%);
    box-shadow: 0 6px 16px rgba(255, 152, 0, 0.4);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

var StatusText = styled.span`
  display: inline-block;
  margin-right: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
`;

export default function ClearCacheButton() {
  // Only show in development mode
  var isDevelopment = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') ||
    (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.includes('192.168.')));

  var [isClearing, setIsClearing] = useState(false);
  var [status, setStatus] = useState("");

  // Don't render in production
  if (!isDevelopment) {
    return null;
  }

  var handleClearCache = async function () {
    if (isClearing) return;

    setIsClearing(true);
    setStatus("در حال پاکسازی...");

    try {
      var result = await clearCache();

      if (result) {
        setStatus("✓ پاکسازی موفق");
        setTimeout(function () {
          setStatus("");
        }, 2000);
      } else {
        setStatus("✗ خطا");
        setTimeout(function () {
          setStatus("");
        }, 2000);
      }
    } catch (error) {
      console.error("[ClearCache] Error:", error);
      setStatus("✗ خطا");
      setTimeout(function () {
        setStatus("");
      }, 2000);
    } finally {
      setIsClearing(false);
    }
  };

  return (
    <ButtonWrapper>
      {status && <StatusText>{status}</StatusText>}
      <CacheButton
        onClick={handleClearCache}
        disabled={isClearing}
        title="پاکسازی کش PWA"
      >
        {isClearing ? "..." : "🗑️ پاک کردن کش"}
      </CacheButton>
    </ButtonWrapper>
  );
}
